

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import {QueryResult, CommonTransformationService, AccountSetting} from '@app/shared';


@Injectable()
export class AccountSettingService {

  constructor (private http: HttpClient, private commonTransService: CommonTransformationService) { }
  getAccountingSettingDefault(): Observable<AccountSetting[]> {
    let url = `/account-settings/default?`;
    return this.http.get<AccountSetting[]>(url);
  }


  updateLookupCode(accountSettingToEdit: AccountSetting): Observable<any> {
    let url = `/finance/lookup-type/` + accountSettingToEdit.ledgerAccountInfo.accountId;
    return this.http.put<any>(url, accountSettingToEdit);
  }

  updateAccountSettings(accountSettingToEdit: AccountSetting): Observable<any> {
    let url = `/account-settings/${accountSettingToEdit.id}`;
    return this.http.put<any>(url, accountSettingToEdit);
  }
}

